import { ref, watch } from 'vue'
import store from '@/store'

/**
 * ユーザーステイタスのソートフィールド
 */
export const USER_STATUS_SORT_FIELD = {
  ACTIVITY: 'activity_change_at',
  ATTRIBUTE: 'attribute',
  BATTERY: 'battery',
  PLACE: 'place_distance',
  POSITIONING: 'last_positioning_at',
  REGISTRATION: 'create_at',
  SENSOR: 'sensor_data',
  USER_NAME: 'user_name',
}

/**
 * 初期ソートルールを取得する
 * @returns {Object}
 */
export const getDefaultSortRule = () => ({
  field: USER_STATUS_SORT_FIELD.POSITIONING,
  isAsc: false,
})

/**
 * ユーザーリストのソートルールを保持・管理
 * @param {number} placeId プレイスID
 */
export function useUserStatusSortRule({ placeId } = {}) {
  /**
   * ソートルール
   * @type {Ref.<Object>}
   */
  const sortRule = ref(getDefaultSortRule())

  /**
   * 引数を反映する
   * @param {Number} placeId プレイスID
   */
  const applyParamter = ({ placeId }) => {
    // placeIdの指定がある場合はプレイス距離昇順に置き換える
    if (placeId) {
      sortRule.value = {
        field: USER_STATUS_SORT_FIELD.PLACE,
        isAsc: true,
      }
    }
  }

  // 変更を store に反映
  watch(sortRule, (value) => {
    store.commit('member/setSortRule', value)
  })

  /**
   * 初期ソートルール設定
   */
  // store の状態反映
  sortRule.value = {
    ...sortRule.value,
    ...store.getters['member/sortRule'],
  }
  // 引数を処理
  applyParamter({ placeId })

  return { sortRule, applyParamter }
}
